<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >   
       <div v-if="needInit">{{initData()}}</div>  

       <v-layout row wrap>
            <v-flex xs4> <v-card outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <a-chapter v-bind:ltype="1"></a-chapter>
            </v-card>  </v-flex>
            <v-flex xs4> <v-card outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <a-chapter v-bind:ltype="2"></a-chapter>
            </v-card>  </v-flex>
            <v-flex xs4>                 
                <v-card>
                    <v-card-title class="layout justify-center">Chapter image:</v-card-title>
                    <v-card-text class="layout justify-center">
                        <v-img
                            v-if="imageURL" 
                            :src="imageURL"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            max-width="100"
                            max-height="100" > </v-img>
                        <v-btn raised class="primary" @click="onPickFile">Upload image</v-btn>
                        <input type="file"
                            accept="image/*" 
                            ref="fileInput"
                            style="display:none"
                            @change="onFilePicked"
                            >
                    </v-card-text>                        
                </v-card>
            </v-flex>                       
               
                 
            <v-flex xs12>
                <v-card outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                        <v-flex xs4>
                            <p>Course:
                                <v-menu v-if="courseList.length > 0" transition="slide-y-transition" bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn large class="my-3" color="primary" v-on="on">
                                            {{ courseList[courseIndex].name}}
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in courseList"
                                            :key="index"
                                            @click="courseIndex = index; courseID = item.id;"
                                        >
                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>  
                                </v-menu>
                            </p>
                        </v-flex>
                            <v-flex xs6>
                                <v-card outlined>
                                    <v-btn @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import AChapter from '../../../elements/AChapter.vue'
import LanguageList from '../../../elements/LanguageList.vue'
import {mapGetters} from 'vuex'
import axios from '../../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             contentUni: null,
             needInit : true,
             imageURL: '',
             image: null,
             courseIndex : 0,
             courseID : 0,
             myOrder: 0,
             courseList: []
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContentUni',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getLanguageList',
                        'getAxiosConfig'
                    ])
    ,
    components: {
        AChapter,
        LanguageList
    },
    methods : {
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.') <=0 ) {
                return alert('Please upload a valid file')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () =>  {
                    this.imageURL = fileReader.result
                }
            )
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        prepareDataforSave() {
            this.$store.commit('setFeedback', null)

            //// xxxxx check data - are there some data to fill?

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContentUni

            this.contentUni = {
                chapter_id : this.myID,
                course_id: this.courseID,
                icon: this.imageURL,
                chapter_order: this.myOrder,
                content_list: []
            }
            
            for(var key in data) {
                this.contentUni.content_list.push( {
                    lang_id : key.replace('l',''),
                    content :  data[key]
                })
            }

            // axios
            axios.post('/create-edit-chapter-all-lang', this.contentUni, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        
        },
        
        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'course_admin_content', params: {id: this.courseID}})   
        },
        initData() {            
            this.needInit = false
            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.myID = this.$route.params.id

            if (this.myID == '0') {
                this.$store.commit('prepareUni','default')
                this.courseID = JSON.parse(localStorage.getItem('position')).activeCourse.id
            } else {
                // load existing data
                axios.get('/get-chapter-in-all-lang/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
                .then(res => {
                    const data = {                        
                        cType: 'default',
                        content_list : res.data.list
                    }

                    this.$store.dispatch('setFullContentUni', data)
                    this.courseID = res.data.course_id
                    this.myOrder = res.data.chapter_order 
                    this.imageURL = res.data.chapter_icon
                })   
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            }

            axios.get('/area-all-courses/' + JSON.parse(localStorage.getItem('position')).activeArea.id, this.$store.getters.getAxiosConfig )
                .then(res => {
                    this.courseIndex = 0
                    this.courseList = []
                    for(let i = 0; i < res.data.list.length; i++) {
                        this.courseList.push( {
                            id: res.data.list[i].id,
                            name: res.data.list[i].title
                        })
                        // set index in list
                        if (res.data.list[i].id == this.courseID) this.courseIndex = i
                    }
                })
                .catch(error => {
                        this.$store.commit('setFeedback', error)
                })                        
        }
    },
    mounted() {
        this.needInit = true
    }      
     
}
</script>
